export const Domain = `ideafounder.com`
export const GAnalytics = `UA-42514162-1`
export const MixPanelKey = `13c8827a10c7b560f28ac751f28e135c`
export const RavenKey = null //`https://2e2bbe6dd914494393a74dfc322cc7b0@sentry.io/122398`
export const MixPanelDebug = false



// WEBPACK FOOTER //
// ./src/config/index.js